import { render, staticRenderFns } from "./GuestComponent.vue?vue&type=template&id=2c8d30c6&scoped=true&lang=pug"
import script from "./GuestComponent.vue?vue&type=script&lang=ts"
export * from "./GuestComponent.vue?vue&type=script&lang=ts"
import style0 from "./GuestComponent.vue?vue&type=style&index=0&id=2c8d30c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d30c6",
  null
  
)

export default component.exports